import React, { useState } from "react";
import { Fade } from 'react-bootstrap';

import { ReactComponent as ArrowDown } from 'assets/images/import-dropdown-not-show-arrow.svg';
import { ReactComponent as ArrowUp } from 'assets/images/import-dropdown-show-arrow.svg';
import AuthButton from "./AuthButton";

const AuthButtonWithDropdown = ({
  className = "",
  disableDropdown = false,
  customDropdownClassName = "",
  permissionRequires = "",
  title = "",
  options = [],
}) => {
  const [showDropdown, setShowDropdown] = useState(false)

  return (
    <AuthButton
      className={`${className} btn-back-button-common import-button-with-dropdown`}
      action={() => {
        if (disableDropdown) {
          return;
        }
        setShowDropdown(!showDropdown);
      }}
      requires={permissionRequires}
    >
      <div>{title}</div>
      {showDropdown ? <ArrowUp className="arrow-svg" /> : <ArrowDown className="arrow-svg" />}
      <Fade in={showDropdown}>
        <div className={`import-customer-dropdown ${customDropdownClassName}`}>
          {options?.map(item =>
            <div
              onClick={item?.action || (() => { })}
            >
              {item?.title || ""}
            </div>
          )}
        </div>
      </Fade>
    </AuthButton>
  );
}

export default AuthButtonWithDropdown;
